import { useState } from "react";
import {
    Text,
    Title1,
    Title2,
    Title3,
    Body1,
    Body2,
    Divider,
    Button,
    Badge,
    tokens,
    makeStyles,
    shorthands,
} from "@fluentui/react-components";
import BodyContainer from "../components/BodyContainer";
import {privacyLanguages} from "../models/Privacy";

const useStyles = makeStyles({
    langToggle: {
        display: "flex",
        gap: "8px",
        marginBottom: "24px",
    },
    section: {
        marginBottom: "28px",
    },
    sectionTitle: {
        marginBottom: "12px",
        display: "block",
    },
    list: {
        paddingLeft: "20px",
        margin: "8px 0",
        lineHeight: "1.8",
    },
    listItem: {
        marginBottom: "4px",
    },
    highlight: {
        backgroundColor: tokens.colorNeutralBackground3,
        ...shorthands.borderRadius("6px"),
        ...shorthands.padding("12px", "16px"),
        marginTop: "8px",
        marginBottom: "8px",
    },
    email: {
        color: tokens.colorBrandForeground1,
        fontWeight: "600",
    },
    badge: {
        marginRight: "8px",
        marginBottom: "4px",
    },
    updatedNote: {
        color: tokens.colorNeutralForeground3,
        marginTop: "32px",
        display: "block",
    },
});

const PrivacyView = () => {
    const [lang, setLang] = useState("nl");
    const styles = useStyles();
    const c = privacyLanguages[lang];


    return (
        <BodyContainer
            showBackButton={true}
            content={
                <>
                    {/* Language toggle */}
                    <div className={styles.langToggle}>
                        <Button
                            as={`a`}
                            appearance={lang === "nl" ? "primary" : "secondary"}
                            size="small"
                            onClick={() => setLang("nl")}
                        >
                            🇳🇱 Nederlands
                        </Button>
                        <Button
                            as={`a`}
                            appearance={lang === "en" ? "primary" : "secondary"}
                            size="small"
                            onClick={() => setLang("en")}
                        >
                            🇬🇧 English
                        </Button>
                    </div>

                    {/* Title */}
                    <Title1 block style={{ marginBottom: "12px" }}>
                        {c.title}
                    </Title1>

                    <Body1 block style={{ marginBottom: "24px", lineHeight: "1.7" }}>
                        {c.intro}
                    </Body1>

                    <Divider style={{ marginBottom: "24px" }} />

                    {/* Sections */}
                    {c.sections.map((section) => (
                        <div key={section.number} className={styles.section}>
                            <Title3 className={styles.sectionTitle}>
                                {section.number} {section.title}
                            </Title3>
                            <div style={{ lineHeight: "1.7" }}>
                                {section.content}
                            </div>
                            <Divider style={{ marginTop: "24px" }} />
                        </div>
                    ))}

                    {/* Footer note */}
                    <Body2 className={styles.updatedNote}>{c.updated}</Body2>

                    {/* Global inline style for email highlight */}
                    <style>{`
                        .privacy-email {
                            color: var(--colorBrandForeground1);
                            font-weight: 600;
                        }
                    `}</style>
                </>
            }
        />
    );
};

export default PrivacyView;
